/**
 * @license
 * Copyright Paysafe 2026. All rights reserved.
 */

/**
 * Checkout error types mapped to Figma error states
 */
export enum CheckoutErrorType {
  // Figma State 1: Insufficient funds
  INSUFFICIENT_FUNDS = 'INSUFFICIENT_FUNDS',

  // Figma State 2: Payment already in progress
  PAYMENT_IN_PROGRESS = 'PAYMENT_IN_PROGRESS',

  // Figma State 3: Service restricted
  WALLET_RESTRICTED = 'WALLET_RESTRICTED',

  // Figma State 4: Payment timed out
  PAYMENT_TIMED_OUT = 'PAYMENT_TIMED_OUT',

  // Figma State 5: Transaction failed
  TRANSACTION_FAILED = 'TRANSACTION_FAILED',

  // Figma State 6: Payment cancelled
  PAYMENT_CANCELLED = 'PAYMENT_CANCELLED',

  // Figma State 7: Limits exceeded
  LIMITS_EXCEEDED = 'LIMITS_EXCEEDED',

  // Figma State 1.1: SCA - Code couldn't be sent
  SCA_CODE_NOT_SENT = 'SCA_CODE_NOT_SENT',

  // Figma State 1.2: SCA - Too many resend requests
  SCA_TOO_MANY_REQUESTS = 'SCA_TOO_MANY_REQUESTS',

  // Figma State 1.3: SCA - Incorrect verification code
  SCA_INCORRECT_CODE = 'SCA_INCORRECT_CODE',

  // Legacy/Fallback types
  GENERAL = 'GENERAL',
  CUSTOM = 'CUSTOM'
}
